import React, { FC } from 'react'
import styles from './ArtAdvisory.module.scss'

const Component: FC = () => {
  return (
    <div className={styles.intro}>
      <p className={`${styles.introText} defaultTypographyH3`}>
        Our free and flexible <span>art advisory service</span> connects you with an expert curator
        to help find art that meets your needs in a smooth and hassle-free process.
      </p>
    </div>
  )
}

export default Component
